import classNames from 'classnames'
import * as React from 'react'
import { isNull, isObject } from '../../guards'
import { renderComplexAnswerLastYear } from '../../services/question/questionHelper'
import { Address } from '../address/index'
import { Alerts } from '../forms/alerts/index'
import { FormFieldProps } from '../forms/formComponentsInterfaces'
import { hasError } from '../forms/index'
import './booksInCareOf.scss'

class BooksInCareOf extends React.Component<FormFieldProps> {
  // tslint:disable-next-line:no-any - value is not typed
  static formatValueLastYear = (value: any): string => {
    return renderComplexAnswerLastYear(
      value.address.name,
      value.address.phone,
      value.address.street1,
      value.address.street2,
      value.address.city,
      value.address.state,
      value.address.postalCode,
      value.address.country
    )
  }

  render () {
    const props = this.props
    const { showAlerts, messages } = props

    if (!isNull(props.value) && !isObject(props.value)) {
      throw new Error(
        `BooksInCareOf expects an object value but received ${JSON.stringify(
          props.value
        )}.`
      )
    }

    const hasErrors = hasError(messages, ['address', 'name'])

    return (
      <div
        className={classNames('form-group bico', {
          'is-valid': !hasErrors,
          'is-invalid': hasErrors,
        })}
      >
        <Address {...{ ...props, showNameField: true }} path='address' />
        {showAlerts && <Alerts messages={messages} />}
      </div>
    )
  }
}

export default BooksInCareOf
